import * as navigationStyles from "../../../styles/layout/navigation.module.scss";

import Image from "../../shared/Image";
import {Link} from "gatsby";
import React from "react";
import {getUserInfoWithoutLogin} from "../../../services/auth";
import {useTranslation} from "react-i18next";
import clsx from "clsx";

const Header = React.memo(function NavigationDesktop({
    logoPartner, logo, name, styleClass
}) {
    const {t} = useTranslation();

    const [userName, setUserName] = React.useState(null);
    React.useEffect(() => {
        const getUserNameAndRoles = async () => {
            const userInfo = await getUserInfoWithoutLogin();
            if (userInfo?.data) {
                if (userInfo.data.firstName || userInfo.data.lastName) {
                    setUserName(userInfo.data.firstName?.charAt(0).toUpperCase() + userInfo.data.lastName?.charAt(0).toUpperCase());
                }
            } else {
                setUserName("");
            }
        };
        if (userName == null) {
            getUserNameAndRoles();
        }
    }, [userName]);

    return (<div className={styleClass ? clsx(navigationStyles.root, styleClass) : navigationStyles.root} role="banner">
        <div className={navigationStyles.rootHeader}>
            <div className={navigationStyles.divLogo}>
                <Link to={logo?.navigationPath} aria-label={t("header.logos.main.arialabel", {website : 'Sciences Po'})}>
                    <Image
                        image={logo}
                        className={navigationStyles.logoSVG}
                        color={navigationStyles.redColor}
                        ariaLabel={t("header.logo")}
                    />
                </Link>
            </div>
            {name !== "_ACCUEIL_SCIENCES_PO_" && (<span className={navigationStyles.titleHeader}>{name}</span>)}
            <div className={navigationStyles.divButtonConnect}>
                <div className={navigationStyles.logoPartner}>
                    {logoPartner && (<div style={{marginRight: 20, height: 60, width: 60, display: 'flex', alignItems:'center', justifyContent:'center'}}>
                        <a href={logoPartner?.linkTo} target="_blank" rel="noreferrer" aria-label={t("header.logos.partner.arialabel", {website : 'Partner Website'})}>
                            <Image
                                image={logoPartner}
                                ariaLabel={t("header.logo.partner")}
                            />
                        </a>
                    </div>)}
                    {/* {AccesCompte} //fonctionnalite pas encore ajoute au site.  */}
                </div>
            </div>
        </div>
    </div>);
});

export default Header;
